import { render } from "./FreshDataForm.vue?vue&type=template&id=0d2eb2f0&scoped=true"
import script from "./FreshDataForm.vue?vue&type=script&lang=js"
export * from "./FreshDataForm.vue?vue&type=script&lang=js"

import "./FreshDataForm.vue?vue&type=style&index=0&id=0d2eb2f0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2eb2f0"]])

export default __exports__